import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-survey-skeleton',
  templateUrl: './survey-skeleton.component.html',
  styleUrls: ['./survey-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class SurveySkeletonComponent {
  @Input() title?: string;
}
